import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MenuItem, ScrollPanel } from 'primeng/primeng';
import { AppComponent } from './app.component';
import { AuthenticationService } from './providers/authentication/authentication.service';
import { EntityManagerProvider } from './providers/entity-manager-provider/entity-manager-provider';
import { PermisosService } from './providers/authentication/permisos.service';

@Component({
	selector: 'app-menu',
	templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit, AfterViewInit {

	@Input() reset: boolean;

	model: any[];
	plegado = false;

	@ViewChild('scrollPanel') layoutMenuScrollerViewChild: ScrollPanel;

	constructor(
		public app: AppComponent,
		public authService: AuthenticationService,
		public entityManager: EntityManagerProvider,
		public permisosService: PermisosService
	) {
		
		this.permisosService.currentMenu
		.subscribe(menu => {
			this.model = menu;
		});
	}

	ngAfterViewInit() {
		setTimeout(() => { this.layoutMenuScrollerViewChild.moveBar(); }, 100);
	}

	ngOnInit() {
		window.scroll(0, 0);
		this.permisosService.construirMenu();
	}


	changeTheme(theme) {
		const themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
		themeLink.href = 'assets/theme/theme-' + theme + '.css';
	}

	changeLayout(theme) {
		const layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');
		layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
	}

	handleClick($event){

		this.app.plegarMenuLateral();

	}
}

@Component({
	/* tslint:disable:component-selector */
	selector: '[app-submenu]',
	templateUrl: './app.submenu.component.html',
	styleUrls: ['./app.submenu.css']
})

export class AppSubMenuComponent {

	@Input() item: MenuItem;

	@Input() root: boolean;

	@Input() visible: boolean;

	_reset: boolean;

	activeIndex: number;

	hover: boolean;

	constructor(public app: AppComponent, public router: Router, public location: Location, public appMenu: AppMenuComponent,
		public authService: AuthenticationService) { }

	itemClick(event: Event, item: MenuItem, index: number)  {

		this.authService.resetFiltroContenido();

		// avoid processing disabled items
		if (item.disabled) {
			event.preventDefault();
			return true;
		}

		// activate current item and deactivate active sibling if any
		if (item.routerLink || item.items || item.command || item.url) {
			this.activeIndex = (this.activeIndex === index) ? null : index;
		}

		// execute command
		if (item.command) {
			item.command({ originalEvent: event, item: item });
		}

		// prevent hash change
		if (item.items || (!item.url && !item.routerLink)) {
			setTimeout(() => {
				this.appMenu.layoutMenuScrollerViewChild.moveBar();
			}, 450);
			event.preventDefault();
		}

		// hide menu
		if (!item.items) {
			if (this.app.isMobile()) {
				this.app.sidebarActive = false;
				this.app.mobileMenuActive = false;
			}
		}
	}

	isActive(index: number): boolean {
		return this.activeIndex === index;
	}

	@Input() get reset(): boolean {
		return this._reset;
	}

	set reset(val: boolean) {
		this._reset = val;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/app.menu.component.ts